export default "/images/google.png?2c89b8cd78647a029ed6ab36145d7518";